import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidenav-text',
  templateUrl: './sidenav-text.component.html',
  styleUrls: ['./sidenav-text.component.scss']
})
export class SidenavTextComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
